{
  "name": "mermaid",
  "version": "11.0.0",
  "description": "Markdown-ish syntax for generating flowcharts, mindmaps, sequence diagrams, class diagrams, gantt charts, git graphs and more.",
  "type": "module",
  "module": "./dist/mermaid.core.mjs",
  "types": "./dist/mermaid.d.ts",
  "exports": {
    ".": {
      "types": "./dist/mermaid.d.ts",
      "import": "./dist/mermaid.core.mjs",
      "default": "./dist/mermaid.core.mjs"
    },
    "./*": "./*"
  },
  "keywords": [
    "diagram",
    "markdown",
    "flowchart",
    "sequence diagram",
    "gantt",
    "class diagram",
    "git graph",
    "mindmap",
    "packet diagram",
    "c4 diagram",
    "er diagram",
    "pie chart",
    "pie diagram",
    "quadrant chart",
    "requirement diagram",
    "graph"
  ],
  "scripts": {
    "clean": "rimraf dist",
    "dev": "pnpm -w dev",
    "docs:code": "typedoc src/defaultConfig.ts src/config.ts src/mermaid.ts && prettier --write ./src/docs/config/setup",
    "docs:build": "rimraf ../../docs && pnpm docs:spellcheck && pnpm docs:code && tsx scripts/docs.cli.mts",
    "docs:verify": "pnpm docs:spellcheck && pnpm docs:code && tsx scripts/docs.cli.mts --verify",
    "docs:pre:vitepress": "pnpm --filter ./src/docs prefetch && rimraf src/vitepress && pnpm docs:code && tsx scripts/docs.cli.mts --vitepress && pnpm --filter ./src/vitepress install --no-frozen-lockfile --ignore-scripts",
    "docs:build:vitepress": "pnpm docs:pre:vitepress && (cd src/vitepress && pnpm run build) && cpy --flat src/docs/landing/ ./src/vitepress/.vitepress/dist/landing",
    "docs:dev": "pnpm docs:pre:vitepress && concurrently \"pnpm --filter ./src/vitepress dev\" \"tsx scripts/docs.cli.mts --watch --vitepress\"",
    "docs:dev:docker": "pnpm docs:pre:vitepress && concurrently \"pnpm --filter ./src/vitepress dev:docker\" \"tsx scripts/docs.cli.mts --watch --vitepress\"",
    "docs:serve": "pnpm docs:build:vitepress && vitepress serve src/vitepress",
    "docs:spellcheck": "cspell \"src/docs/**/*.md\"",
    "docs:release-version": "tsx scripts/update-release-version.mts",
    "docs:verify-version": "tsx scripts/update-release-version.mts --verify",
    "types:build-config": "tsx scripts/create-types-from-json-schema.mts",
    "types:verify-config": "tsx scripts/create-types-from-json-schema.mts --verify",
    "checkCircle": "npx madge --circular ./src",
    "release": "pnpm build",
    "prepublishOnly": "cpy '../../README.*' ./ --cwd=. && pnpm docs:release-version && pnpm -w run build"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/mermaid-js/mermaid"
  },
  "author": "Knut Sveidqvist",
  "license": "MIT",
  "standard": {
    "ignore": [
      "**/parser/*.js",
      "dist/**/*.js",
      "cypress/**/*.js"
    ],
    "globals": [
      "page"
    ]
  },
  "dependencies": {
    "@braintree/sanitize-url": "^7.0.1",
    "@mermaid-js/parser": "workspace:^",
    "cytoscape": "^3.29.2",
    "cytoscape-cose-bilkent": "^4.1.0",
    "d3": "^7.9.0",
    "d3-sankey": "^0.12.3",
    "dagre-d3-es": "7.0.10",
    "dayjs": "^1.11.10",
    "dompurify": "^3.0.11",
    "katex": "^0.16.9",
    "khroma": "^2.1.0",
    "lodash-es": "^4.17.21",
    "marked": "^13.0.2",
    "roughjs": "^4.6.6",
    "stylis": "^4.3.1",
    "ts-dedent": "^2.2.0",
    "uuid": "^9.0.1"
  },
  "devDependencies": {
    "@adobe/jsonschema2md": "^8.0.0",
    "@types/cytoscape": "^3.21.4",
    "@types/d3": "^7.4.3",
    "@types/d3-sankey": "^0.12.4",
    "@types/d3-scale": "^4.0.8",
    "@types/d3-scale-chromatic": "^3.0.3",
    "@types/d3-selection": "^3.0.10",
    "@types/d3-shape": "^3.1.6",
    "@types/dompurify": "^3.0.5",
    "@types/jsdom": "^21.1.6",
    "@types/katex": "^0.16.7",
    "@types/lodash-es": "^4.17.12",
    "@types/micromatch": "^4.0.6",
    "@types/prettier": "^3.0.0",
    "@types/stylis": "^4.2.5",
    "@types/uuid": "^9.0.8",
    "ajv": "^8.12.0",
    "chokidar": "^3.6.0",
    "concurrently": "^8.2.2",
    "cpy-cli": "^5.0.0",
    "csstree-validator": "^3.0.0",
    "globby": "^14.0.1",
    "jison": "^0.4.18",
    "js-base64": "^3.7.7",
    "jsdom": "^24.0.0",
    "json-schema-to-typescript": "^13.1.2",
    "micromatch": "^4.0.5",
    "path-browserify": "^1.0.1",
    "prettier": "^3.2.5",
    "remark": "^15.0.1",
    "remark-frontmatter": "^5.0.0",
    "remark-gfm": "^4.0.0",
    "rimraf": "^5.0.5",
    "start-server-and-test": "^2.0.3",
    "type-fest": "^4.13.1",
    "typedoc": "^0.25.12",
    "typedoc-plugin-markdown": "^3.17.1",
    "typescript": "~5.4.3",
    "unist-util-flatmap": "^1.0.0",
    "unist-util-visit": "^5.0.0",
    "vitepress": "^1.0.1",
    "vitepress-plugin-search": "1.0.4-alpha.22"
  },
  "files": [
    "dist/",
    "README.md"
  ],
  "publishConfig": {
    "access": "public"
  }
}
